<template>
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <div class="modal-header">
        Select Part
        <CloseSvg
          class="close"
          :dark="true"
          @click="onCloseClicked"
        />
      </div>
      <div class="modal-content">
        <InventorySearch
          :show-add="true"
          :supplier-id="supplierId"
          @inventory-item="onInventoryItemSelected"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import CloseSvg from '@/components/svgs/CloseSvg.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import Toaster from '@meforma/vue-toaster'
import InventorySearch from '@/components/elements/InventorySearch.vue'
import { InventoryItem } from '@/@types/responses/inventory_item/InventoryItem'

export default defineComponent({
  name: 'SelectPartModal',
  components: {
    CloseSvg,
    InventorySearch
  },
  props: {
    supplierId: {
      type: Number,
      default: undefined
    }
  },
  emits: ['close', 'inventory-item'],
  setup() {
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster

    return {
      toast
    }
  },
  mounted() {
    document.body.addEventListener('keyup', this.onKeyup)
  },
  unmounted() {
    document.body.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    onCloseClicked(): void {
      this.$emit('close')
    },
    onKeyup(e: KeyboardEvent): void {
      if (e.key === 'Escape' || e.key === 'Esc')
        this.onCloseClicked()
    },
    onInventoryItemSelected(inventoryItem: InventoryItem): void {
      this.$emit('inventory-item', inventoryItem)
    }
  }
})
</script>

<style scoped lang="scss">
.modal-overlay {
  @include modal-styles;
}

.modal-overlay > .modal-content-wrapper {
  background-color: $Color-white;

  @include desktop {
    height: 80%;
    width: 80%;
    position: relative;
  }
  
  > .modal-content {
    bottom: 0;
    padding: 0;

    @include desktop {
      position: absolute;
    }
  }
  
  > .spinner {
    text-align: center;
  }
}
</style>